<template>
  <v-button class="c-refresh-button" variant="outline-primary" size="sm" @click="$emit('refresh')">
    <span class="sr-only">{{ $t('white-label.globalLabels.refresh') }}</span>
    <font-awesome-icon :icon="['fas', 'sync']" />
  </v-button>
</template>

<script>
import { library as fontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/pro-solid-svg-icons';
fontAwesomeLibrary.add(faSync);

export default {};
</script>

<style lang="scss">
.c-refresh-button {
  border-color: var(--gray-400);
  padding: 0.1em 0.5em;
}
</style>
